import React from 'react';

import OhsMultiLoginPlaceDialog from './OhsMultiLoginPlaceDialog';
import { OhsMultiUserLoginOption } from './OhsMultiUserLoginOption';

interface Props {
  open: boolean;
  userOptions: OhsMultiUserLoginOption[];
}
export default function OhsMultiLogin(props: Props) {
  const { userOptions, open } = props;

  return <OhsMultiLoginPlaceDialog open={open} onClose={() => {}} userOptions={userOptions} />;
}
